import Company from '../models/Company'
import {action, makeObservable, observable} from 'mobx'
import {post} from '../common/requester'
import CompanyQuery from "../models/CompanyQuery";
import Agreement, {AGREEMENT_CLUB1_OWNER} from "../models/Agreement";

class AdminStore {
  company = new Company()
  companies = []
  companies_query = new CompanyQuery()
  agreement = new Agreement()
  agreements = []
  
  constructor() {
    makeObservable(this, {
      company: observable,
      companies: observable,
      companies_query: observable,
      resetCompany: action,
      setCompanies: action,
      searchCompanies: action,
      confirmStatus: action,
      agreement: observable,
      agreements: observable,
      getAgreements: action,
      getAgreement: action,
      initAgreement: action,
      deleteAgreement: action,
      setActiveAgreement: action,
      setAgreements: action
    })
  }
  
  resetCompany() {
    this.company = new Company()
  }
  
  setCompanies(companies) {
    this.companies = companies
  }
  
  async searchCompanies() {
    const response = await post('adm/companies', this.companies_query).catch((err) => console.error('--companies error', err))
    if (response && response.result === 0) {
      this.setCompanies(response.items)
      this.companies_query.setProperty('count', response.count)
      this.companies_query.setProperty('page_number', response.page_number)
      this.companies_query.setProperty('page_count', response.page_count)
    }
    return Promise.resolve(response)
  }
  
  async confirmStatus(companyId) {
    const resp = await post('adm/confirm', {company_id: companyId}).catch(err => console.log('--error', err.message))
    if (resp && resp.result === 0) {
      this.searchCompanies()
    }
  }
  
  async getAgreements(params) {
    const ret = await post("agreement/list", params);
    this.setAgreements(ret.items.map((x) => new Agreement().setFromJson(x)))
  }
  
  async getAgreement(id) {
    const ret = await post("agreement/get", {id}).catch((err) => console.log(err))
    
    const a = new Agreement();
    a.setFromJson(ret);
    this.agreement = a;
  }
  
  async deleteAgreement(id) {
    const ret = await post("agreement/delete", {id}).then(() => {
      this.agreements = (this.agreements || []).filter((x) => x.id !== id);
    }).catch((err) => console.log(err))
  }
  
  setAgreements(agr) {
    this.agreements = agr
  }
  
  async setActiveAgreement(id) {
    const ret = await post("agreement/set_active", {id}).catch((err) => console.log(err))
  
    this.setAgreements((this.agreements || []).map((x) => {
        x.setProperty("is_active", x.id === id);
        return x;
      })
    )
    return ret;
  }
  
  initAgreement() {
    const a = new Agreement();
    
    a.setProperty("id", null);
    a.setProperty("company_id", null);
    a.setProperty("type", AGREEMENT_CLUB1_OWNER);
    a.setProperty("title", "");
    a.setProperty("text", "");
    a.setProperty("version", new Date().toISOString().slice(0, 10));
    a.setProperty("is_active", true);
    
    this.agreement = a;
    return a;
  }
  
  
}

const adminStore = new AdminStore();
export default adminStore;